<template>
  <div v-if="hasCategories()" class="categories">
    <div class="c-title-wrap mar-top-40">
      <p class="c-title">展现栏目</p>
    </div>
    <div class="business" v-for="(item, index) in bizList" :key="index">
      <div class="business_tit">
        <strong>{{ item.name }}</strong>
      </div>
      <div class="column" v-for="(item1, index1) in item.contentCategorys" :key="index1">
        <div class="column_tit">
          <div class="cloumn_tit_label">栏目{{ index1 + 1 }}</div>
          <!--  :class="[item1.isChecked ? 'tabs' : '']" -->
          <div class="column_tit_value" :class="[item1.isChecked ? 'tabs' : '']">
            {{ item1.name }}
          </div>
        </div>
        <div class="channels" v-if="item1.contentChannels">
          <div class="channel" v-for="(item2, index2) in item1.contentChannels" :key="index2" @click.stop="clickChannelAndUpdateCategoryAndBiz(item2)" :class="[item2.isChecked ? 'tabs' : '']">
            <p>{{ item2.name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { request } from '@/utils/axios';

export default {
  name: "BusinessColumnChannel",
  props: ['requestConfigs'],
  data() {
    return {
      // 文章ID
      articleId: null,
      // 查询文章接口返回的原始数据
      res: {},
      // =================================user only start====================================
      user_identity: 0, // 身份信息
      // =================================user only end====================================
      contentBusinesses: [], // 关联业务
      contentCategorys: [], // 关联栏目、频道
      contentChannels: [], // 频道
      // =================================man only start====================================
      isFirstChooseBizTag: true, // 初始化是否第一次点击业务标签的标识，如果点击过，则置该值为false,在标题提交的时候有用。
      // user: 用户端 , man: 运营端
      app_type: process.env.VUE_APP_TYPE,
      bizList: [],
    };
  },
  async created() {
    if (this.$route.query.id) {
      this.articleId = this.$route.query.id;
    }
    this.user_identity = sessionStorage.getItem("user_identity");
    await this.getListContentBizDetailForAuditData();
    this.displayBusinessColumnChannelToHtml();
    // 用户端 未知 医护 写手角色，没有该字段
    // if (this.hasCategories()) {
    //   try {
    //     await this.getListContentBizDetailForAuditData();
    //     this.displayBusinessColumnChannelToHtml();
    //   } catch (e) {
    //     console.log(e);
    //   }
    // }
  },
  methods: {
    hasCategories() {
      return this.app_type == 'man' || this.user_identity == 3;
    },
    // 保存文章之前，构造业务栏目频道的标签的提交表单数据。
    getBizListData(parentForm) {
      // 用户端 未知 医护 写手角色，没有该字段，所以直接返回了
      if (!this.bizList || !this.bizList.length) {
        return;
      }
      // 先置空原来的值
      this.contentCategorys = [];
      this.contentBusinesses = [];
      this.contentChannels = [];
      // 开始构建用户目前选择的值
      this.bizList.forEach((item) => {
        if (item.contentCategorys && item.contentCategorys.length > 0) {
          item.contentCategorys.forEach(value => {
            // 栏目
            let arr = [];
            if (value.isChecked) {
              value.contentChannels && value.contentChannels.forEach(label => {
                  // 频道
                  if (label.isChecked) {
                    // console.log(label,'1')
                    // arr.push({id: label.id, name: label.name});
                    this.contentChannels.push({businessId: label.contentBusinessId, categoryId: label.contentCategoryId, channelId: label.id});
                  }
                });
              // console.log(value,'2')
              // this.contentCategorys.push({id: value.id, contentChannels: arr});
            }
          });
          if (item.isChecked)
            this.contentBusinesses.push({id: item.id, name: item.name});
        }
      });
      // 写手端特有的逻辑（此逻辑应该是放在后台的，现有接口不太友好） backend TODO
      if (this.app_type == "user") {
        // 如果是保存过的。
        if (this.articleId) {
          // 如果写手是运营身份
          if (this.user_identity == 3) {
            // 如果用户都不勾选，则传原来没有保存之前返回的数据中的业务，如果用i户有勾选，则传用户勾选的，上面的逻辑已经筛选了用户勾选的值
            if (this.contentBusinesses.length == 0) {
              if (this.res.contentBusinesses && this.res.contentBusinesses.length > 0) {
                this.contentBusinesses = this.res.contentBusinesses;
              } else {
                // 理论上保存过的文章应该这里都有值，但是现在错误数据（本来此处应该后台修复数据库错误数据，现在没有处理，由前端暂时处理）
                this.bizList.forEach(item => {
                  this.contentBusinesses.push({id: item.id, name: item.name
                  });
                });
              }
            }
          } else {
            // 如果写手是非运营身份，则每次保存都使用全部业务覆盖之前审核人员设置过的业务
            this.contentBusinesses = [];
            this.bizList.forEach(item => {
              this.contentBusinesses.push({id: item.id, name: item.name
              });
            });
          }
        } else {
          // 如果用户没有保存过的。是新建文章
          if (this.contentBusinesses.length == 0) {
            // 如果用户一个也没有选择，则传所有的业务标签
            this.bizList.forEach(item => {
              this.contentBusinesses.push({id: item.id, name: item.name
              });
            });
          } else {
            // 如果用户选择了，则传用户选择的
          }
        }
      } else {
        // 运营端人员特有的逻辑代码
        // 用户关联的是A业务，如果运营人员审核文章的时候，不点击操作业务栏目区域，那么提交的时候需要传业务A，
        // 但是如果运营人员审核文章的时候点击的是B业务，那么提交的时候不要传业务A，如果再次点击B业务取消选中，这时候也不传A业务
        if (this.isFirstChooseBizTag) {
          this.contentBusinesses = this.res.contentBusinesses || [];
        }
      }
      // parentForm.contentCategorys = this.contentCategorys;
      parentForm.contentBusinesses = this.contentBusinesses;
      parentForm.contentChannels = this.contentChannels;
    },
    // 将数据展示到界面上面的方法
    displayBusinessColumnChannelToHtml() {
      // 返显业务栏目频道 用户端：未知 医护 写手角色，没有该字段，所以直接返回了
      if (this.bizList) {
        for (var i = 0; i < this.bizList.length; i++) {
          var biz = this.bizList[i];
          if (biz.contentCategorys)
            // 栏目
            for (var j = 0; j < biz.contentCategorys.length; j++) {
              var ctg = biz.contentCategorys[j];
              if (this.contentChannels) {
                // 频道
                this.contentChannels.forEach(val => {
                  if (val.categoryId == ctg.id) {
                    ctg.isChecked = true; // 栏目
                    biz.isChecked = true; // 业务
                  }
                });
                if(ctg.contentChannels && ctg.contentChannels.length){
                  for (var k = 0; k < ctg.contentChannels.length; k++) {
                    var channel = ctg.contentChannels[k];
                    this.contentChannels.forEach(val => {
                      if (channel.id == val.channelId) {
                        channel.isChecked = true;
                      }
                    });
                  }
                }
                
              }
            }
        }
      }
    },
    refresh(data) {
      this.res = data.res;
      this.articleId = data.articleId || null;
      this.contentBusinesses = data.contentBusinesses || [];
      this.contentCategorys = data.contentCategorys || [];
      this.contentChannels = data.contentChannels || [];
      // 每次重置数据之后，需要重新设置bizList的所有数据中的isCheck数据，确保页面上面展示的勾选状态是正确的。
      this.setAllTagToUnchecked();
      this.displayBusinessColumnChannelToHtml();
    },
    // 重置所有业务栏目渠道标签的选中状态为不选中
    setAllTagToUnchecked() {
      this.bizList.forEach(item => {
        item.isChecked = false;
        item.contentCategorys &&
          item.contentCategorys.forEach(val => {
            val.isChecked = false;
            val.contentChannels &&
              val.contentChannels.forEach(label => {
                label.isChecked = false;
              });
          });
      });
    },
    // 查询文章展示的业务信息, 并设置业务栏目频道的isChecked字段值为false
    async getListContentBizDetailForAuditData() {
      this.bizList = await request(this.requestConfigs.getAllUserSetedBizColChannels.functionId, this.requestConfigs.getAllUserSetedBizColChannels.params);
      this.bizList.forEach(item => {
        this.$set(item, "isChecked", false);
        item.contentCategorys &&
          item.contentCategorys.forEach(val => {
            this.$set(val, "isChecked", false);
            val.contentChannels &&
              val.contentChannels.forEach(label => {
                this.$set(label, "isChecked", false);
              });
          });
      });
    },
    // 点击DOM界面上的标签的时候，修改界面绑定的this.bizList中的isChecked值改变页面上面业务栏目标签选中状态.
    clickChannelAndUpdateCategoryAndBiz(val) {
      // 记录用户是否第一次点击，该值用于判断最后提交给后台接口的参数contentBusinesses值的变化。具体逻辑请看方法getBizListData
      this.isFirstChooseBizTag = false;
      val.isChecked = !val.isChecked;
      for (var i = 0; i < this.bizList.length; i++) {
        var biz = this.bizList[i];
        var isBizExisted = false;
        if (biz.contentCategorys) {
          for (var j = 0; j < biz.contentCategorys.length; j++) {
            var isCategoryExisted = false;
            var category = biz.contentCategorys[j];
            if (category.contentChannels) {
              for (var k = 0; k < category.contentChannels.length; k++) {
                var channel = category.contentChannels[k];
                if (channel.isChecked) {
                  isCategoryExisted = true;
                  break;
                }
              }
              category.isChecked = isCategoryExisted;
              if (isCategoryExisted) {
                isBizExisted = true;
              }
            } else {
              isBizExisted = category.isChecked = false;
              break;
            }
          }
          biz.isChecked = isBizExisted;
        } else {
          biz.isChecked = false;
          break;
        }
      }
    },
  }
};

</script>
<style lang="scss" scoped>
@import "@/assets/css/common/mixin.scss";

.categories {
  line-height: 30px;
  font-size: 16px;

  .business {
    padding-left: 28px;
    margin-right: 20px;
    margin-bottom: 10px;
    @include singleline-ellipsis;

    .business_tit {
      margin-bottom: 20px;
      font-family: PingFangSC-Medium;
      font-size: 14px;
      height: 20px;
      color: rgba(51, 56, 64, 1);
      margin-top: 27px;
    }

    .column {
      margin: 0px 20px 0px 21px;
      position: relative;

      .column_tit {
        margin-bottom: 20px;
        font-size: 14px;
        color: rgba(95, 95, 107, 1);
        text-align: center;
        display: flex;

        .cloumn_tit_label {
          width: 60px;
          text-align: right;
        }

        &:nth-child(1) {
          margin-top: 36px;
        }

        margin-top: 105px;

        .column_tit_value {
          height: 34px;
          padding: 6px 21px;
          margin-left: 10px;
          //border: 1px solid rgba(216, 220, 229, 1);
          border-radius: 4px;
          line-height: 16px;
          border: 1px solid rgba(216, 220, 229, 1);
          border-radius: 4px;
        }

        @include singleline-ellipsis;
      }

      .channels {
        display: flex;
        margin-top: 21px;
        padding-left: 70px;
        display: flex;
        flex-wrap: wrap;

        .channel {
          height: 34px;
          padding: 6px 38px;
          border: 1px solid rgba(216, 220, 229, 1);
          border-radius: 4px;
          line-height: 20px;
          // height: 32px;
          border: 1px solid rgba(216, 220, 229, 1);
          border-radius: 4px;
          margin-right: 30px;
          cursor: pointer;
          max-width: 200px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 28px;

          p {
            height: 21px;
            font-size: 14px;
            color: rgba(95, 95, 107, 1);
            line-height: 21px;
            @include singleline-ellipsis;
          }
        }
      }
    }
  }

  .tabs {
    border: 1px solid #0058ee !important;
    border-radius: 4px !important;
    color: #0058ee !important;
    background: url("~@/assets/choose.png") right bottom no-repeat;
    background-size: 18px;

    span {
      color: #0058ee !important;
    }

    .have {
      cursor: pointer;
    }

    .button.el-button.el-button--default {
      padding-top: 10px;
    }
  }
}

</style>
